module.exports = __webpack_public_path__ + "static/media/niuniu_pc_game.90ec4f3.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameVideo/niuniu_pc_game.mp4
// module id = AOxs
// module chunks = 0